import { z } from 'zod'

import { BelongStatus } from './BelongStatus'

export const NonDayBelongReport = z.object({
  types: z.array(
    z.object({
      status: BelongStatus,
      amount: z.number()
    })
  ),
  belongs: z.array(
    z.object({
      period: z.string(),
      belongs: z.array(
        z.object({
          status: BelongStatus,
          amount: z.number()
        })
      )
    })
  )
})
export type NonDayBelongReport = z.infer<typeof NonDayBelongReport>
